import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyIconLegend from './CurrencyIconLegend/CurrencyIconLegend';
import GameSpeedIconLegend from './GameSpeedIconLegend/GameSpeedIconLegend';
import GameTypesIconLegend from './GameTypesIconLegend/GameTypesIconLegend';
import { TXTCLI_Icon_Legend } from './IconLegend.messages.json';
import styles from './IconLegend.scss';
import TableSizeIconLegend from './TableSizeIconLegend/TableSizeIconLegend';

const IconLegend: React.FC = () => (
  <div className={styles.container}>
    <p className={styles.title}>
      <Translation {...TXTCLI_Icon_Legend} />
    </p>
    <div className={styles.legendsWrap}>
      <TableSizeIconLegend />
      <GameSpeedIconLegend />
      <CurrencyIconLegend />
      <GameTypesIconLegend />
    </div>
  </div>
);

export default IconLegend;
